<template>
  <header class="sidd-chat-header-web-direct">
    <div class="sidd-chat-header__content">
      <div class="sidd-chat-header__left">
        <Button
          variant="ghost"
          size="icon"
          class="sidd-chat-header__menu"
          aria-label="Open sidebar"
          @click="emit('menu')"
        >
          <Menu :size="20" />
        </Button>
      </div>

      <div class="sidd-chat-header__center"></div>

      <div class="sidd-chat-header__right">
        <ClearHistoryButton />
        <Button
          v-if="showSourcesButton"
          variant="ghost"
          size="icon"
          class="sidd-chat-header__source"
          :aria-label="sourceButtonLabel"
          @click="emit('source')"
        >
          <FileText :size="20" />
        </Button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button } from '@/lib/ui/button'
import { FileText, Menu } from 'lucide-vue-next'
import { useChatbot } from '@/composables/useChatbot'
import ClearHistoryButton from './ClearHistoryButton.vue'
import type { IHeaderWebDirectEmits, IHeaderWebDirectProps } from './types'

defineProps<IHeaderWebDirectProps>()

const emit = defineEmits<IHeaderWebDirectEmits>()

const chatbot = useChatbot()

const showSourcesButton = computed(() => {
  return chatbot.store.configuration?.showSourceAttribution ?? false
})

const sourceButtonLabel = computed(() => 'Show sources')
</script>

<style>
.sidd-chat-header__content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  max-width: 100%;
}

.sidd-chat-header-web-direct {
  background: hsl(var(--background));
  padding: 8px !important;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.sidd-chat-header__left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.sidd-chat-header__center {
  flex: 1;
  min-width: 0;
}

.sidd-chat-header__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
</style>
